module.exports = __webpack_public_path__ + "img/Tractor-Outline.60a1a6d0.png";